import classNames from 'classnames'
import { bool, node, oneOf, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import { BUTTON_STYLES } from 'views/components/atoms/Button/consts'

import './ButtonWithIcons.scss'

const STYLE_BUTTON_LINK_WITH_ICON = 'buttonLinkWithIcon'

const ButtonWithIcons = props => {
  const {
    children,
    icon,
    right,
    buttonWithIconNoText,
    style,
    className,
    ...rest
  } = props

  const buttonStyle = style === STYLE_BUTTON_LINK_WITH_ICON ? null : style

  const classes = classNames(
    'm-ButtonWithIcons',
    {
      'm-ButtonWithIcons--withIconNoText': buttonWithIconNoText,
      'm-ButtonWithIcons--linkWithIcon': style === STYLE_BUTTON_LINK_WITH_ICON,
      'l-flex__row_reverse': right,
    },
    className
  )

  let iconClass = ''
  if (!right && !buttonWithIconNoText) {
    iconClass =
      'u-display--inline-block u-margin-x-small--right m-ButtonWithIcons__icon'
  }

  if (right && !buttonWithIconNoText) {
    iconClass = 'u-display--inline-block u-margin-x-small--left'
  }

  return (
    <Button style={buttonStyle} {...rest} className={classes}>
      <div className={iconClass}>{icon}</div>
      {children}
    </Button>
  )
}

ButtonWithIcons.propTypes = {
  icon: node,
  right: bool,
  buttonWithIconNoText: bool,
  className: string,
  ...Button.propTypes,
  style: oneOf([...BUTTON_STYLES, STYLE_BUTTON_LINK_WITH_ICON]),
}

ButtonWithIcons.defaultProps = {
  children: '',
  icon: null,
  right: false,
  className: null,
  buttonWithIconNoText: false,
  ...Button.defaultProps,
  style: null,
}

export default ButtonWithIcons
